import React, {Component} from 'react';
import { getAbsoluteAssetUrl, getCoverImageByModelName } from '../constants/album-ebads';

export default class DashboardDetail extends Component {

    render() {
        const value = this.props.orders[this.props.el];
        const displayValue = (value === 'null' || value === null || value === undefined || value === '') ? 'Yok' : value;
        const coverImage = this.props.el === 'p_coverModel'
            ? getAbsoluteAssetUrl(getCoverImageByModelName(value))
            : null;

        return (
            <li className="dashboard-detail-list">
                <span>
                    <strong>{this.props.label}</strong>
                    <small>{displayValue}</small>
                    {coverImage ? (
                        <img
                            src={coverImage}
                            alt={`${displayValue} kapak görseli`}
                            className="order-cover-print-image"
                        />
                    ) : null}
                </span>
            </li>
        );
    }
}
